import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Rx';

import { AuthorizeApi } from "@rx/security"
import { RxHttp, RequestQueryParams, LookupAction } from '@rx/http';
import { UsersSearchViewModel, UsersResultModel } from "app/components/users/domain/users.models";
import { User } from "app/database-models";


@Injectable()
export class UsersService {
    private get apiUsers(): AuthorizeApi {
        var authorizeApi: AuthorizeApi = {
            api: `api/users`,
            applicationModuleId: 8,
            keyName: 'userId'
        }
        return authorizeApi;
    }
    private get api(): AuthorizeApi {
        var authorizeApi: AuthorizeApi = {
            api: `api/UsersSearch`,
            applicationModuleId: 8,
            keyName: 'userId'
        }
        return authorizeApi;
    }
    constructor(
        private http: RxHttp
    ) { }
    searchUsersList(usersSearch: UsersSearchViewModel): Observable<UsersResultModel[]> {
        return this.http.post<UsersResultModel[]>(this.api, usersSearch,false);
    }
    lookup<UsersLookupGroup>(lookupActions: LookupAction[]): Promise<UsersLookupGroup> {
        return this.http.lookup<UsersLookupGroup>(lookupActions);
    }
    post(user: User,showtoast:boolean =true ): Observable<UsersResultModel[]> {
        return this.http.post<UsersResultModel[]>(this.apiUsers, user,showtoast);
    }
    put(user: User): Observable<UsersResultModel[]> {
        return this.http.put<UsersResultModel[]>(this.apiUsers, user);
    }
    group<UsersLookupGroup>(params: any[] | {
        [key: string]: any;
    } | RequestQueryParams, lookupActions: LookupAction[]): Promise<UsersLookupGroup> {
        return this.http.group<UsersLookupGroup>(this.apiUsers, params, 'user', lookupActions);
    }
    delete(id: number): Observable<UsersResultModel[]> {
        return this.http.delete<UsersResultModel[]>(this.apiUsers, id);
    }
    hardDelete(id: number): Observable<UsersResultModel[]> {
        var apiMessageUser:AuthorizeApi = this.apiUsers;
        apiMessageUser.api = `api/users/HardDelete` 
        return this.http.delete<UsersResultModel[]>(apiMessageUser, id);
    }
    get(): Observable<User[]> {
        return this.http.get<User[]>(this.apiUsers);
    }

    GetProjectUsers(projectId:any)
    {
        var apiProjectUsres:AuthorizeApi = this.apiUsers;
        apiProjectUsres.api = `api/users/GetProjectUsers/${projectId}`
        return this.http.get<any>(apiProjectUsres);
    } 

    GetMessageUsers(projectId:any)
    {
        var apiMessageUser:AuthorizeApi = this.apiUsers;
        apiMessageUser.api = `api/users/GetMessageUsers/${projectId}` 
        return this.http.get<any>(apiMessageUser);  
    }

    getUniqueEmail(email : string)
    {
       
        var apiMessageUser:AuthorizeApi = this.api;
        apiMessageUser.api = `api/users/GetUniqueEmail/${email}` 
        return this.http.get<any>(apiMessageUser);  
    }

  
}



// WEBPACK FOOTER //
// ./src/app/components/users/users.service.ts